import styled from "@emotion/styled";

import { fontMerriweather } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 10px;

  border: 10px solid #e5e5e5;

  background: #e5e5e5;
`;

export const Item = styled(EntityLink)`
  display: flex;
  gap: 12px;

  padding: 14px;

  background-color: #ffffff;
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: 22px;
`;

export const StyledBaseImage = styled(BaseImage)`
  flex-shrink: 0;

  inline-size: 80px;
  block-size: 80px;

  border-radius: 4px;
`;
